var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroEffective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FEFBFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.252 18V31.1837M30.252 31.1837H14.0886C12.3828 31.1837 11 32.5665 11 34.2723V37M30.252 31.1837H44.9114C46.6172 31.1837 48 32.5665 48 34.2723V37M30.252 31.1837V37",
    stroke: "#FEFBFF",
    strokeWidth: 1.15823
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6584 14.6462C33.3383 14.6462 35.5108 12.4737 35.5108 9.79378C35.5108 7.11389 33.3383 4.94141 30.6584 4.94141C27.9785 4.94141 25.806 7.11389 25.806 9.79378C25.806 12.4737 27.9785 14.6462 30.6584 14.6462Z",
    fill: "#E54E6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6585 17.0723C25.7965 17.0723 21.8369 20.3331 21.8369 24.3508C21.8369 24.6226 22.0504 24.8361 22.3222 24.8361H38.9949C39.2667 24.8361 39.4802 24.6226 39.4802 24.3508C39.4802 20.3331 35.5206 17.0723 30.6585 17.0723Z",
    fill: "#E54E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5124 40.9988C16.5124 37.9544 14.0444 35.4863 10.9999 35.4863C7.95546 35.4863 5.48743 37.9544 5.48743 40.9988C5.48743 44.0433 7.95546 46.5113 10.9999 46.5113C14.0444 46.5113 16.5124 44.0433 16.5124 40.9988Z",
    fill: "#E54E6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0275 39.6742L10.3758 42.3258L9.04999 41",
    stroke: "#FEFBFF",
    strokeWidth: 0.69779,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5124 40.9988C35.5124 37.9544 33.0444 35.4863 29.9999 35.4863C26.9555 35.4863 24.4874 37.9544 24.4874 40.9988C24.4874 44.0433 26.9555 46.5113 29.9999 46.5113C33.0444 46.5113 35.5124 44.0433 35.5124 40.9988Z",
    fill: "#E54E6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0275 39.6742L29.3758 42.3258L28.05 41",
    stroke: "#FEFBFF",
    strokeWidth: 0.69779,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5124 40.9988C53.5124 37.9544 51.0444 35.4863 47.9999 35.4863C44.9555 35.4863 42.4874 37.9544 42.4874 40.9988C42.4874 44.0433 44.9555 46.5113 47.9999 46.5113C51.0444 46.5113 53.5124 44.0433 53.5124 40.9988Z",
    fill: "#E54E6D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0275 39.6742L47.3758 42.3258L46.05 41",
    stroke: "#FEFBFF",
    strokeWidth: 0.69779,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroEffective);
export default __webpack_public_path__ + "static/media/heroEffective.dbbf1823648e3ae7001b075120e11181.svg";
export { ForwardRef as ReactComponent };